import {
  getCurrencies,
  deleteCurrency,
  createCurrency,
  getCurrencyById,
  editCurrency,
  getCurrencyView,
} from "@/http/system/currencyMaster.js";

export default {
  namespaced: true,
  state: {
    currencyList: [],
    getDeleteCurrencyResp: null,
    createCurrency: null,
    currencyById: {},
    currencyView: "",
    updateCurrency: null,
    rolesList: [],
    formError: null,
    permissionByRole: {},
  },
  actions: {
    async setCurrencyList({ commit }) {
      try {
        const resp = await getCurrencies();
        commit("SET_CURRENCY_LIST", resp.data.pageItems);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setdeleteCurrency({ commit }, id) {
      try {
        const resp = await deleteCurrency(id);
        commit("SET_DELETE_CURRENCY_DATA", resp.data.resourceId);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setPostCurrency({ commit, state }, data) {
      try {
        if (state.formError != null) {
          commit("FORM_ERROR", null);
        }
        if (state.createCurrency != null) commit("SET_POST_CURRENCY", null);
        const resp = await createCurrency(data);

        if (resp.data.resourceId) {
          commit("SET_POST_CURRENCY", resp.data.resourceId);
          return resp;
        }
      } catch (e) {
        if (state.formError != null) {
          commit("FORM_ERROR", null);
        }
        // commit(types.FORM_ERROR, e.currency.errors[0].defaultUserMessage);

        return e.currency;
      }
    },
    async setCurrencyById({ commit }, data) {
      try {
        const response = await getCurrencyById(data);
        commit("SET_CURRENCY_BY_ID", response.data);
        return response;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getCurrencyViewAction({ commit }, data) {
      try {
        const response = await getCurrencyView(data);
        commit("SET_CURRENCY_VIEW", response.data);
        return response;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setPutCurrency({ commit, state }, data) {
      try {
        if (state.formError != null) {
          commit("FORM_ERROR", null);
        }
        if (state.createCurrency != null) commit("SET_PUT_CURRENCY", null);
        const resp = await editCurrency(data.id, data.currency);

        if (resp.data.resourceId) {
          commit("SET_PUT_CURRENCY", resp.data.resourceId);
          return resp;
        }
      } catch (e) {
        if (state.formError != null) {
          commit("FORM_ERROR", null);
        }
        commit("FORM_ERROR", e.message.errors[0].defaultUserMessage);

        return e.currency;
      }
    },
  },
  mutations: {
    SET_CURRENCY_LIST(state, payload) {
      state.currencyList = payload;
    },
    SET_CURRENCY_VIEW(state, payload) {
      state.currencyView = payload;
    },
    SET_DELETE_CURRENCY_DATA(state, payload) {
      state.getDeleteCurrencyResp = payload;
    },
    SET_POST_CURRENCY(state, payload) {
      state.createCurrency = payload;
    },
    SET_CURRENCY_BY_ID(state, payload) {
      state.currencyById = payload;
    },
    SET_PUT_CURRENCY(state, payload) {
      state.updateCurrency = payload;
    },
  },
  getters: {
    getCurrencyList(state) {
      return state.currencyList;
    },
    saveCurrencyResponse(state) {
      return state.createCurrency;
    },
    getCurrencyCode(state) {
      return state.getCurrencyById;
    },
  },
};
